var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("settings-editor-base", {
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var inputId = ref.inputId
          return [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-4" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.model,
                      expression: "model"
                    }
                  ],
                  ref: "input",
                  attrs: { id: inputId, type: "checkbox" },
                  domProps: {
                    value: _vm.value,
                    checked: Array.isArray(_vm.model)
                      ? _vm._i(_vm.model, _vm.value) > -1
                      : _vm.model
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.model,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = _vm.value,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.model = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.model = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.model = $$c
                      }
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-8" }, [
                _c("label", { attrs: { for: inputId } }, [
                  _vm._v(_vm._s(_vm.text))
                ])
              ])
            ])
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }